<template>
	<div class="card bg-base-100 shadow">
		<div class="card-body">
			<div class="flex flex-wrap items-center justify-between gap-3">
				<div class="flex items-center gap-3">
					<div class="card-title flex items-center gap-2 text-xl">
						{{ t('inventory.header.title') }}
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- <div class="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
				<div
					v-for="stat in statsCards"
					:key="stat.label"
					class="group rounded-2xl border border-base-200 bg-base-100/80 p-4 shadow transition hover:-translate-y-1 hover:border-primary/40 hover:shadow-xl">
					<div class="flex items-center justify-between">
						<span class="text-sm font-medium text-base-content/60">{{ stat.label }}</span>
						<span class="rounded-full bg-primary/10 p-2 text-primary group-hover:bg-primary/20">
							<component :is="stat.icon" class="h-4 w-4" />
						</span>
					</div>
					<p class="mt-4 text-2xl font-semibold text-base-content">
						{{ stat.value }}
					</p>
					<p class="mt-1 text-xs text-base-content/50">{{ stat.caption }}</p>
				</div>
			</div> -->
</template>

<script setup lang="ts">
	import { useI18n } from 'vue-i18n'
	import { _translations } from '../_translations'

	const { t } = useI18n(_translations)
	// import dayjs from 'dayjs'
	// import { computed } from 'vue'
	// import { Archive, Boxes, DollarSign, ShieldCheck } from 'lucide-vue-next'
	// import { useInventory } from '../useInventory'

	// const { stats, items } = useInventory()

	// const statsCards = computed(() => {
	// 	const { totalItems, calibrationRequired, projectCount, totalValue } = stats.value
	// 	return [
	// 		{
	// 			label: 'Total items',
	// 			value: totalItems.toLocaleString(),
	// 			caption: 'Tracked assets in the catalogue',
	// 			icon: Boxes,
	// 		},
	// 		{
	// 			label: 'Calibration needed',
	// 			value: calibrationRequired.toLocaleString(),
	// 			caption: 'Items flagged for calibration',
	// 			icon: ShieldCheck,
	// 		},
	// 		{
	// 			label: 'Active projects',
	// 			value: projectCount.toLocaleString(),
	// 			caption: 'Projects with assigned inventory',
	// 			icon: Archive,
	// 		},
	// 		{
	// 			label: 'Total value',
	// 			value: formatCurrency(totalValue),
	// 			caption: 'Sum of gross prices (EUR)',
	// 			icon: DollarSign,
	// 		},
	// 	]
	// })

	// const lastUpdated = computed(() => {
	// 	const timestamps = items.value
	// 		.map((item) => Number(item.modified || item.created || 0))
	// 		.filter((value) => Number.isFinite(value) && value > 0)
	// 	if (!timestamps.length) return '—'
	// 	const mostRecent = Math.max(...timestamps)
	// 	return dayjs(mostRecent).format('DD MMM YYYY · HH:mm')
	// })


</script>
